import { GET_CONFIG, SET_SIGNALR_GROUPS } from '../actionTypes';

/**
 * initial state data
 */
const initialState: any = {};

/**
 * Reducer for managing the config state
 * @param state
 * @param action
 * @returns
 */
const configReducer = (state = initialState, action: any): any => {
  let payload: any;
  switch (action.type) {
    case GET_CONFIG:
      payload = Object.assign({}, action.data);
      return { ...state, payload };
    case SET_SIGNALR_GROUPS:
      return { ...state, signalrGroups: action.data };
    default:
      return {
        ...state,
      };
  }
};
export default configReducer;
